var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 14C23.7667 14 24.6667 13.1 24.6667 12C24.6667 10.9 23.7667 10 22.6667 10C21.5667 10 20.6667 10.9 20.6667 12C20.6667 13.1 21.5667 14 22.6667 14ZM18.9667 17.4L16.4136 30.2567C16.2858 30.9002 16.7782 31.5 17.4343 31.5C17.9209 31.5 18.3426 31.1627 18.4495 30.6878L20.0667 23.5L22.1667 25.5V30.5C22.1667 31.0523 22.6144 31.5 23.1667 31.5C23.719 31.5 24.1667 31.0523 24.1667 30.5V24L22.0667 22L22.6667 19C23.7672 20.2698 25.3694 21.1813 27.1698 21.4312C27.7169 21.5071 28.1667 21.0523 28.1667 20.5C28.1667 19.9477 27.7149 19.5103 27.1725 19.4062C25.7165 19.1269 24.5227 18.2479 23.8667 17.1L22.8667 15.5C22.4667 14.9 21.8667 14.5 21.1667 14.5C20.8667 14.5 20.6667 14.6 20.3667 14.6L15.1667 16.8V20.5C15.1667 21.0523 15.6144 21.5 16.1667 21.5C16.719 21.5 17.1667 21.0523 17.1667 20.5V18.1L18.9667 17.4Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkMode);
export default __webpack_public_path__ + "static/media/walkMode.191b6bae27857f57b1db243e20900bae.svg";
export { ForwardRef as ReactComponent };